const elStagesListMobile = document.querySelectorAll('.stages__mobile--trigger');

elStagesListMobile.forEach ( elStagesListMobile => {

    elStagesListMobile.addEventListener('click', function (e) {

        const elStagesListMobileTrigger = e.target.closest('.stages__mobile--trigger');

        const isStagesListMobileOpen = elStagesListMobileTrigger.classList.contains('stages--opened')


        if (isStagesListMobileOpen) {
            return
        }

        document.querySelectorAll('.stages__mobile--trigger').forEach(el => {
            el.classList.remove('stages--opened');
        });
        elStagesListMobileTrigger.classList.add('stages--opened');
    
		const stagesKey = elStagesListMobileTrigger.dataset.key;

		document.querySelectorAll('.stages').forEach(el => {
            el.classList.remove('stages--opened');
        });

		const elStagesContainer = document.querySelector(`.stages[data-key="${stagesKey}"]`)

		elStagesContainer.classList.add('stages--opened');
	})


});
